import i18next from "i18next";
import * as yup from "yup";

export function validation() {
  return yup.object().shape({
    // description: yup
    //   .string()
    //   .required(i18next.t("validation.createMemories.description"))
    //   .min(3, "Minimum 3 Character required")
    //   .trim(i18next.t("validation.common.noSpace")),
    title: yup
      .string()
      .required(i18next.t("validation.createMemories.album"))
      .max(50, i18next.t("validation.common.enter50Char"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    // date: yup.string().required(i18next.t("validation.createMemories.date")),
    location: yup.string(),
    albumImage: yup.string().required("File is required"),
  });
}
